import { useEffect, useRef, useState } from "react";

const vanImage = "https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/f162fe8647417439dff93a9f7bc3af92.jpeg";

export default function HeroSlider() {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imgRef.current?.complete) {
      setLoaded(true);
    }
  }, []);

  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      {/* Single van image */}
      <div className="absolute inset-0">
        <img
          ref={imgRef}
          src={vanImage}
          alt="Ultimate Heating & Cooling service van"
          onLoad={() => setLoaded(true)}
          className={`w-full h-full object-cover object-center transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B2447]/90 via-[#0B2447]/60 to-[#0B2447]/30 md:from-[#0B2447]/85 md:via-[#0B2447]/50 md:to-transparent"></div>
      </div>

      {/* Left-aligned content */}
      <div className="relative z-10 w-full h-full flex items-center">
        <div className="max-w-7xl mx-auto px-5 md:px-10 w-full">
          <div className="max-w-xl">
            <span className="inline-block bg-[#C8102E] text-white text-[10px] font-bold tracking-[0.2em] px-3 py-1.5 rounded-full mb-4">
              ULTIMATE HEATING & COOLING
            </span>
            <h1 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-white mb-3 md:mb-4 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Connecticut&apos;s Trusted HVAC Pros
            </h1>
            <p className="text-white/80 text-sm md:text-base mb-6 md:mb-8 leading-relaxed max-w-sm md:max-w-none">
              Same-day heating and cooling repairs, full system replacements, and emergency service — we&apos;re the team homeowners call first.
            </p>
            <div className="flex flex-col sm:flex-row gap-2.5 sm:gap-3">
              <a
                href="#contact"
                className="bg-[#C8102E] text-white text-xs font-bold px-6 py-3 rounded-full hover:bg-[#A8091D] transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                GET A FREE QUOTE
              </a>
              <a
                href="tel:9592418524"
                className="border-2 border-white/60 text-white text-xs font-bold px-6 py-3 rounded-full hover:border-white hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-1.5"
              >
                <i className="ri-phone-fill"></i> CALL (959)241-8524
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}